import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from '../shared.module';

/**
 * La confirmation unique des actions destructives (revue design T2) : une
 * feuille du bas avec la ligne de titre commune, le message, l'action en
 * `vw-button look="danger"` pleine largeur (jeton `vw-danger`) et « Annuler »
 * en discret dessous. Ni emoji, ni icône dans les boutons.
 *
 * `danger=false` pour une action sans perte (arrêter un partage) : bouton
 * principal vert. Pendant `loading`, l'action tourne et « Annuler » attend ;
 * `error` dit l'échec au-dessus des boutons.
 * Libellés et textes arrivent déjà traduits ; `cancelLabel` est une clé.
 */
@Component({
  selector: 'vw-confirm-dialog',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() message = '';
  @Input() confirmLabel = '';
  @Input() cancelLabel = '';
  @Input() danger = true;
  @Input() loading = false;
  /** Échec de l'action, déjà traduit : la feuille reste ouverte pour réessayer. */
  @Input() error = '';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
